import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aa83c48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "club-voucher-actions-page"
}
const _hoisted_2 = { class: "club-voucher-actions-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "club-voucher-actions-footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectPriceTypeView = _resolveComponent("SelectPriceTypeView")!
  const _component_ViewHeader = _resolveComponent("ViewHeader")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showSelectPriceTypeView)
      ? (_openBlock(), _createBlock(_component_SelectPriceTypeView, {
          key: 0,
          isClub: true,
          onOnSelectOrderPriceType: _ctx.manualOrder
        }, null, 8, ["onOnSelectOrderPriceType"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ViewHeader, { text: '' }),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.clubSelected)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "circle",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scanVoucher && _ctx.scanVoucher(...args)))
                }, _toDisplayString(_ctx.$t("cashier.scan-voucher")), 1))
              : _createCommentVNode("", true),
            (_ctx.clubSelected)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "circle",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSelectPriceTypeView = true))
                }, _toDisplayString(_ctx.$t("cashier.manual-order")), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_3
        ]))
  ]))
}